export const FLASH_REPORT_VENUE_CONFIRM_COUNT = 40

export const shouldConfirmFlashReportSize = count =>
  Number(count) > FLASH_REPORT_VENUE_CONFIRM_COUNT

export const flashReportLargeGroupQuestion = count =>
  `This flash report has ${count} venues. Generate it now?`
